import actions from '/actions/actionTypes'

export const setLoading = loading => {
  return loading
    ? { type: actions.LOADING_PENDING }
    : { type: actions.LOADING_DONE }
}
